import * as React from 'react';
const MOBILE_BREAKPOINT = 600;

/**
 * Returns the current mobile state, or `undefined` during SSR and the
 * first client render. Callers must gate rendering on the defined
 * value — otherwise the sidebar swaps tree shapes (desktop -> Sheet)
 * after the first effect tick and triggers a hydration mismatch.
 */
export function useIsMobile(): boolean | undefined {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);
  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}